export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  cover: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  isFeatured: boolean;
}

export const articles: Article[] = [
  {
    id: 'art-001',
    title: '2024年必备的10款效率办公软件推荐',
    summary: '精选10款提升工作效率的必备软件，涵盖文档处理、项目管理、时间规划等领域，助你成为高效职场人。',
    content: `在数字化办公时代，选择合适的效率工具至关重要。本文将为您推荐10款经过实测的高效办公软件。

## 1. WPS Office 2024
国产办公软件标杆，完美兼容微软Office格式，内置AI写作助手，支持云端协作。无论是日常文档处理还是复杂的数据分析，WPS都能轻松应对。

## 2. 腾讯会议
远程办公时代不可或缺的视频会议工具，支持300人同时在线，AI降噪效果出色，屏幕共享流畅无延迟。

## 3. Notion
全能型笔记与知识管理工具，集文档、数据库、日历于一体，高度自定义的工作空间让信息管理变得简单有序。

## 4. XMind
专业思维导图软件，帮助梳理思路、规划项目、头脑风暴，多种模板和样式让思考可视化。

## 5. 飞书
新一代企业协作平台，即时通讯、文档协作、视频会议、日历管理一站式解决，提升团队协作效率。

## 6. Todoist
简洁高效的待办事项管理工具，支持自然语言输入、项目分类、优先级设置，让任务管理不再混乱。

## 7. Snipaste
轻量级截图贴图工具，截图后可贴在桌面作为参考，设计师和开发者的效率利器。

## 8. Everything
Windows文件搜索神器，秒级定位任意文件，比系统自带搜索快百倍，电脑文件再多也不怕。

## 9. Bandizip
纯净无广告的压缩解压工具，支持50+格式，解压速度比同类快6倍，必备装机软件。

## 10. QuickLook
空格键预览文件内容，支持图片、文档、视频等格式，macOS用户最怀念的Windows效率工具。

选择适合自己的工具组合，让工作效率倍增！`,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20workspace%20with%20laptop%20and%20notebook%20on%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20clean%20aesthetic%2C%20productivity%20concept%2C%20soft%20shadows%2C%20professional%20photography%20style&width=800&height=450&seq=article-cover-001&orientation=landscape',
    category: 'articles',
    author: '问鼎编辑部',
    date: '2024-08-10',
    readTime: '8分钟',
    tags: ['办公软件', '效率工具', '软件推荐'],
    isFeatured: true,
  },
  {
    id: 'art-002',
    title: '电脑变慢怎么办？5招让你的电脑重获新生',
    summary: '电脑使用久了越来越卡？不用担心，教你5个简单有效的优化技巧，让老旧电脑也能流畅运行。',
    content: `电脑使用一段时间后变慢是很多人的困扰。别急着换电脑，试试下面这5招！

## 1. 清理系统垃圾
使用360安全卫士或CCleaner清理临时文件、缓存和注册表垃圾，释放磁盘空间。

## 2. 禁用开机自启项
打开任务管理器，在"启动"选项卡中禁用不必要的开机自启程序，大幅缩短开机时间。

## 3. 升级固态硬盘
如果还在使用机械硬盘，升级到SSD是最显著的性能提升方式，开机速度可从分钟级降到秒级。

## 4. 增加内存
8GB是当前基本配置，如果经常多任务操作，建议升级到16GB或更高。

## 5. 定期杀毒与系统更新
保持系统和安全软件更新，定期全盘扫描，防止恶意软件拖慢系统。

坚持以上5点，你的电脑至少能再战三年！`,
    cover: 'https://readdy.ai/api/search-image?query=Clean%20modern%20computer%20repair%20workspace%20with%20tools%20and%20laptop%2C%20warm%20lighting%2C%20tech%20maintenance%20concept%2C%20professional%20photography%20style&width=800&height=450&seq=article-cover-002&orientation=landscape',
    category: 'articles',
    author: '问鼎技术团队',
    date: '2024-08-05',
    readTime: '5分钟',
    tags: ['电脑优化', '系统维护', '实用技巧'],
    isFeatured: true,
  },
  {
    id: 'art-003',
    title: '2024年最值得期待的手游大作盘点',
    summary: '盘点2024年下半年即将上线的热门手游大作，从开放世界到策略竞技，总有一款适合你。',
    content: `2024年下半年手游市场精彩纷呈，多款大作即将上线。让我们一起来看看有哪些值得期待的作品。

## 《绝区零》
米哈游最新都市幻想ARPG，独特的高速战斗系统和潮流美术风格，已吸引全球数千万预约。

## 《永劫无间手游》
端游大逃杀经典移植，保留飞索格斗核心玩法，针对移动端操作做了专门优化。

## 《鸣潮》
开放世界动作RPG，高自由度探索和爽快连招战斗，画面表现力达到移动端新高度。

## 《三角洲行动》
腾讯天美工作室战术FPS手游，还原经典三角洲系列硬核枪战体验。

## 《心动小镇》
治愈系社交模拟经营游戏，建设你的梦想小镇，与好友一起享受悠闲生活。

这么多精彩游戏即将到来，你的手机存储还够用吗？`,
    cover: 'https://readdy.ai/api/search-image?query=Exciting%20mobile%20gaming%20concept%20with%20smartphone%20displaying%20colorful%20game%20graphics%2C%20dark%20background%20with%20neon%20accents%2C%20dynamic%20composition%2C%20modern%20gaming%20aesthetic&width=800&height=450&seq=article-cover-003&orientation=landscape',
    category: 'articles',
    author: '问鼎游戏频道',
    date: '2024-07-28',
    readTime: '6分钟',
    tags: ['手游', '游戏推荐', '新游盘点'],
    isFeatured: true,
  },
  {
    id: 'art-004',
    title: '从零开始学编程：新手入门工具全攻略',
    summary: '编程入门不知道从哪开始？本文为你整理了零基础学编程必备的开发工具和学习资源。',
    content: `想学编程但不知道从哪里开始？这份新手攻略帮你快速上手！

## 选择第一门语言
推荐从Python开始，语法简洁、应用广泛，适合零基础入门。或者选择JavaScript，可以直接在浏览器中看到效果。

## 必备开发工具
- **VS Code**：免费开源的代码编辑器，插件丰富，绝大多数开发者的首选。
- **Git**：版本控制工具，记录代码变更历史，团队协作必备。
- **Chrome DevTools**：浏览器开发者工具，前端调试利器。

## 学习资源推荐
- 官方文档永远是最好的学习资料
- B站/YouTube免费教程
- 力扣/牛客网练习算法
- GitHub参与开源项目实践

## 学习路径建议
1. 基础语法（1-2个月）
2. 小项目实战（2-3个月）
3. 框架学习（2-3个月）
4. 完整项目（持续）

编程学习贵在坚持，每天进步一点点！`,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20coding%20setup%20with%20laptop%20showing%20code%20editor%20on%20desk%2C%20warm%20lighting%2C%20clean%20minimalist%20workspace%2C%20learning%20programming%20concept&width=800&height=450&seq=article-cover-004&orientation=landscape',
    category: 'articles',
    author: '问鼎技术团队',
    date: '2024-07-20',
    readTime: '7分钟',
    tags: ['编程入门', '开发工具', '学习指南'],
    isFeatured: false,
  },
  {
    id: 'art-005',
    title: '手机应用权限管理指南：保护你的隐私安全',
    summary: '手机应用过度索取权限怎么办？详解Android和iOS权限管理技巧，守护个人隐私安全。',
    content: `手机应用权限管理是保护个人隐私的重要一环。很多应用在安装时会索取各种权限，学会管理它们至关重要。

## 哪些权限需要警惕？
- **通讯录**：社交类应用需要，但计算器也要通讯录就不正常
- **位置信息**：地图导航需要，但手电筒应用要定位就有问题
- **摄像头/麦克风**：拍照视频需要，但阅读应用要摄像头就得警惕
- **短信**：验证码自动填充需要，其他场景要谨慎

## Android权限管理
进入设置→应用管理→权限管理，可以按权限类型或应用查看，关闭不必要权限。

## iOS权限管理
设置→隐私与安全性，逐项检查各应用的权限设置，iOS 14+还会在应用使用麦克风/摄像头时提示。

## 下载应用的建议
- 只从官方应用商店下载
- 查看应用评论和评分
- 注意应用开发者是否可信
- 安装前检查所需权限是否合理

保护隐私从权限管理开始！`,
    cover: 'https://readdy.ai/api/search-image?query=Smartphone%20privacy%20security%20concept%20with%20lock%20icon%20on%20phone%20screen%2C%20dark%20background%2C%20modern%20tech%20aesthetic%2C%20clean%20composition&width=800&height=450&seq=article-cover-005&orientation=landscape',
    category: 'articles',
    author: '问鼎安全频道',
    date: '2024-07-15',
    readTime: '5分钟',
    tags: ['隐私安全', '手机技巧', '安全指南'],
    isFeatured: false,
  },
  {
    id: 'art-006',
    title: '设计师必备：2024年最好用的免费设计工具',
    summary: '盘点2024年设计师最爱的免费设计工具，从UI设计到图片处理，专业级工具不花一分钱。',
    content: `好的设计工具不一定贵！以下免费工具同样能满足专业设计需求。

## Figma
基于浏览器的UI/UX设计工具，实时协作功能强大，已成为设计行业新标准。免费版功能已足够个人使用。

## Canva
在线平面设计平台，海量模板和素材，零基础也能做出精美设计。社交媒体配图、海报、名片轻松搞定。

## GIMP
开源免费的图像处理软件，功能媲美Photoshop，支持图层、滤镜、蒙版等专业功能。

## Inkscape
开源矢量图形编辑器，支持SVG格式，适合LOGO设计、插画创作。

## Blender
开源3D创作套件，建模、渲染、动画、视频编辑一应俱全，社区资源丰富。

## DaVinci Resolve
专业级免费视频调色与剪辑软件，好莱坞级别的调色工具，完全免费使用。

选择合适的工具，创意不设限！`,
    cover: 'https://readdy.ai/api/search-image?query=Creative%20designer%20workspace%20with%20color%20palette%20and%20sketches%2C%20warm%20natural%20lighting%2C%20artistic%20aesthetic%2C%20professional%20photography&width=800&height=450&seq=article-cover-006&orientation=landscape',
    category: 'articles',
    author: '问鼎设计频道',
    date: '2024-07-08',
    readTime: '6分钟',
    tags: ['设计工具', '免费软件', '设计师'],
    isFeatured: false,
  },
];